import { render, staticRenderFns } from "./MobileFiltersPlaceholder.vue?vue&type=template&id=3ba4b9b8"
import script from "./MobileFiltersPlaceholder.vue?vue&type=script&lang=js"
export * from "./MobileFiltersPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports